import { Component, inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { MeteringPointMeteredDataSourceService } from '@app/api/dmc';
import { FormApiService } from '@app/core/services/form-api.service';
import { AlertComponent } from '@shared/components/alert/alert.component';
import { TableComponent } from '@shared/components/table/table.component';
import { TableConfig } from '@shared/interfaces/table/table-config';
import { validFromPartialTable } from '@shared/partials/validfrom-partial.table';
import {
  meteringPointSourceValidToColumn,
  MeteringPointSourceRow
} from '@shared/table-configs/meteringpoint/meteringpoint-source.table';

/** Confirms and removes the selected source relations from the metering point's source timeline. */
@Component({
  selector: 'app-remove-source-modal',
  imports: [
    TranslatePipe,
    AlertComponent,
    TableComponent,
  ],
  templateUrl: './remove-source-modal.component.html',
})
export class RemoveSourceModalComponent implements OnInit {
  private readonly formApiService = inject(FormApiService);
  private readonly sourceService = inject(MeteringPointMeteredDataSourceService);

  /** Set by ModalService. */
  public meteringPointIdentification?: string;
  public elements: MeteringPointSourceRow[] = [];

  public readonly tableConfig: TableConfig<MeteringPointSourceRow> = {
    id: 'meteringpoint-source-remove',
    pagination: false,
    columns: [
      {
        title: 'meteringpoint.source.source',
        key: 'sourceText'
      },
      validFromPartialTable,
      meteringPointSourceValidToColumn,
    ],
  };

  public readonly form = new FormGroup({
    meteringPointIdentification: new FormControl<string | null>(null, Validators.required),
    relationIds: new FormControl<string[]>([], Validators.required),
  });

  public ngOnInit(): void {
    this.form.setValue({
      meteringPointIdentification: this.meteringPointIdentification ?? null,
      relationIds: this.elements.map(element => element.id!).filter(id => !!id),
    });
  }

  public submit(): void {
    this.formApiService.submit(
      this.form,
      data => this.sourceService.meteringPointMeteredDataSourceRemovePost(data),
      {
        successMessage: 'meteringpoint.source.remove.success',
        closeModal: true,
      }
    );
  }
}
